import {
    SkyNetSpreadSheetConfigType,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    AdditionalFeesTable,
} from 'app/Apps/Rates/RateCards/AdditionalFees/AdditionalFees.types'
import {
    AdditionalFeesConfigParams,
    getCommonAdditionalFeesFields,
    createSpreadsheetConfig,
} from 'app/Apps/Rates/components/AdditionalFeesSpreadsheet/AdditionalFeesSpreadsheet.config'

export default function getAPricingAdditionalFeesConfig(
    params: AdditionalFeesConfigParams,
): SkyNetSpreadSheetConfigType<keyof AdditionalFeesTable> {
    const titleOverrides: Partial<Record<keyof AdditionalFeesTable, string>> = {
        feeName: 'ADDITIONAL_FEE',
        description: 'A_QUOTE_DESCRIPTION',
    }

    const fields = getCommonAdditionalFeesFields(params).map((field) => {
        const labelKey = titleOverrides[field.name]

        return labelKey ? {
            ...field, title: params.getLabel(labelKey),
        } : field
    })

    return createSpreadsheetConfig(fields)
}
